/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES 企業の管理画面用 API
 * PR TIMES 企業の管理画面で使うAPI。basePathは今後変わる事も想定している。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { OurMediaOutletMediaType } from './OurMediaOutletMediaType';
import {
    OurMediaOutletMediaTypeFromJSON,
    OurMediaOutletMediaTypeFromJSONTyped,
    OurMediaOutletMediaTypeToJSON,
} from './OurMediaOutletMediaType';

/**
 * 
 * @export
 * @interface OurMediaOutlet
 */
export interface OurMediaOutlet {
    /**
     * メディアID
     * @type {number}
     * @memberof OurMediaOutlet
     */
    mediaOutletId: number;
    /**
     * 
     * @type {OurMediaOutletMediaType}
     * @memberof OurMediaOutlet
     */
    mediaType: OurMediaOutletMediaType;
    /**
     * メディア名
     * @type {string}
     * @memberof OurMediaOutlet
     */
    mediaName: string;
    /**
     * 企業名
     * @type {string}
     * @memberof OurMediaOutlet
     */
    companyName: string;
    /**
     * 担当者名
     * @type {string}
     * @memberof OurMediaOutlet
     */
    personInChargeName: string;
    /**
     * 所属部署
     * @type {string}
     * @memberof OurMediaOutlet
     */
    department: string;
    /**
     * メールアドレス（未設定の場合は空文字）
     * @type {string}
     * @memberof OurMediaOutlet
     */
    email: string;
    /**
     * 電話番号（未設定の場合は空文字）
     * @type {string}
     * @memberof OurMediaOutlet
     */
    phoneNumber: string;
    /**
     * FAX（未設定の場合は空文字）
     * @type {string}
     * @memberof OurMediaOutlet
     */
    faxNumber: string;
    /**
     * ワンクリック登録解除されているかどうか
     * @type {boolean}
     * @memberof OurMediaOutlet
     */
    isUnsubscribe: boolean;
    /**
     * 形式(Y-m-d\TH:i:sP)
     * @type {string}
     * @memberof OurMediaOutlet
     */
    updatedAt: string;
}

/**
 * Check if a given object implements the OurMediaOutlet interface.
 */
export function instanceOfOurMediaOutlet(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "mediaOutletId" in value;
    isInstance = isInstance && "mediaType" in value;
    isInstance = isInstance && "mediaName" in value;
    isInstance = isInstance && "companyName" in value;
    isInstance = isInstance && "personInChargeName" in value;
    isInstance = isInstance && "department" in value;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "phoneNumber" in value;
    isInstance = isInstance && "faxNumber" in value;
    isInstance = isInstance && "isUnsubscribe" in value;
    isInstance = isInstance && "updatedAt" in value;

    return isInstance;
}

export function OurMediaOutletFromJSON(json: any): OurMediaOutlet {
    return OurMediaOutletFromJSONTyped(json, false);
}

export function OurMediaOutletFromJSONTyped(json: any, ignoreDiscriminator: boolean): OurMediaOutlet {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'mediaOutletId': json['media_outlet_id'],
        'mediaType': OurMediaOutletMediaTypeFromJSON(json['media_type']),
        'mediaName': json['media_name'],
        'companyName': json['company_name'],
        'personInChargeName': json['person_in_charge_name'],
        'department': json['department'],
        'email': json['email'],
        'phoneNumber': json['phone_number'],
        'faxNumber': json['fax_number'],
        'isUnsubscribe': json['is_unsubscribe'],
        'updatedAt': json['updated_at'],
    };
}

export function OurMediaOutletToJSON(value?: OurMediaOutlet | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'media_outlet_id': value.mediaOutletId,
        'media_type': OurMediaOutletMediaTypeToJSON(value.mediaType),
        'media_name': value.mediaName,
        'company_name': value.companyName,
        'person_in_charge_name': value.personInChargeName,
        'department': value.department,
        'email': value.email,
        'phone_number': value.phoneNumber,
        'fax_number': value.faxNumber,
        'is_unsubscribe': value.isUnsubscribe,
        'updated_at': value.updatedAt,
    };
}

